import { FC, useState } from 'react';

import { Box, Typography } from '@mui/material';

interface OtpTimerProps {
    onTimeout: () => void;
    isValid: boolean;
}

const OtpTimer: FC<OtpTimerProps> = ({ onTimeout, isValid }) => {
    const [timeLeft, setTimeLeft] = useState(60);
    const timerRef = React.useRef<NodeJS.Timeout>();

    const startTimer = () => {
        timerRef.current = setInterval(() => {
            setTimeLeft((time) => {
                if (time <= 0) {
                    clearInterval(timerRef.current);
                    onTimeout();
                    return 0;
                }
                return time - 1;
            });
        }, 1000);
    };

    React.useEffect(() => {
        if (isValid) {
            setTimeLeft(60);
            startTimer();
        }
        return () => {
            clearInterval(timerRef.current);
        };
    }, [isValid]);

    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <Typography variant="subtitle1" color={timeLeft > 10 ? 'textPrimary' : 'error'}>
                {`0:${timeLeft < 10 ? `0${timeLeft}` : timeLeft}`}
            </Typography>
        </Box>
    );
};

export default OtpTimer;
